module.exports = __webpack_public_path__ + "img/426.74910904.png";